export default "__VITE_ASSET__DD6Twddh__"